<template>
  <div >
    <!-- header-->
    <headertop></headertop>
    <el-row class="main_sta" style="padding-top: 1.875rem;">
      <!-- <el-empty description="暂无内容,正在飞快的上传中,尽请期待"></el-empty> -->
      <el-col :span="5" :offset="1">
        <el-table
          :data="list_info.list.passage"
           border
           height	="calc(100vh - 200px) "
           :header-cell-style="{'text-align':'center'}"
           :row-style="isRed"
          style="width: 100%;font-size: 14px;letter-spacing: 0.1875rem; ">
          <el-table-column
            prop="name"
            :label="list_info.list.book"
            >
            <template slot-scope="scope">
              <div style="cursor: pointer;font-size: 0.625rem;"  @click="handleEdit(scope.row)">{{scope.row.name}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="17":offset="1" >
        <el-row>
        </el-row>
        <div style="min-height: calc(100vh - 230px);overflow-x: hidden;" class="log_content">
          <el-input
            v-model="input"
            placeholder="本章内容搜索"
            prefix-icon="el-icon-search"
            clearable
            size="small"
            style="width: 30%;float: right;"
            @keyup.enter.native="search"
          >
          </el-input>
          <h2 style="text-align: center;">{{list_info.list.content.name}}</h2>
          <div style="max-height: calc(100vh - 300px);overflow-x: hidden;" id="con" >
            <span   style="font-size: 0.875rem;" v-html="list_info.list.content.content"></span>
          </div>
        </div>
        <el-row style="margin-top: 0.625rem; " >
           <el-button  round type="primary" size='mini' v-if="list_info.xz_name[0].passage != list_info.list.passage[0].passage" @click="next('Last')">上一章</el-button>
           <el-button round  type="primary" size='mini' v-if="list_info.xz_name[0].passage != list_info.len.passage" style="float: right;" @click="next('Next')">下一章</el-button>
        </el-row>
      </el-col>
    </el-row>
    <!-- footer -->
    <!-- <footerbom></footerbom> -->
  </div>
</template>

<script>
  import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        input:'',
        content:'',
        list_info:{
          list:{},
          src:'',
          num:this.$route.query.book,
          passage_num:'',
          xz_name:[],
          len:'',
        }
      }
    },

    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted:function(){
      if(this.$route.query.passage_num!=''){
        this.list_info.passage_num=this.$route.query.passage_num
      }
      this.get_list()
    },
    methods: {
    search() {
      let _this=this
      _this.list_info.list.content.content=_this.content
      if(_this.input==''){
        return
      }
      let re=_this.list_info.list.content.content
      var reg1 = /<script[^>]*>(.|\n)*<\/script>/gi
      var sText = re.replace(reg1, "")
      var bgColor="#d30b15"
      var num = -1
      var rStr = new RegExp(_this.input, "gi"); //匹配传入的搜索值不区分大小写 i表示不区分大小写，g表示全局搜索
      var rHtml = new RegExp("\<.*?\>", "ig");//匹配html元素
      var aHtml = sText.match(rHtml); //存放html元素的数组
      var arr = sText.match(rStr);
      // var a = -1;
      sText = sText.replace(rHtml, '{~}');  //替换html标签
      sText = sText.replace(rStr, function () {
            // a++;
            return "<span name='addSpan' style='color: " + bgColor + ";'>" + _this.input + "</span>"
      }); //替换key
      sText = sText.replace(/{~}/g, function () {  //恢复html标签
            num++;
            return aHtml[num];
      });
      _this.list_info.list.content.content=sText
    },
      next(type){
        let _this=this
        if(type=='Next'){
          for(let i=0;i<_this.list_info.list.passage.length;i++){
            if(_this.list_info.list.passage[i].passage==_this.list_info.xz_name[0].passage){
              _this.handleEdit(_this.list_info.list.passage[i+1])
              return
            }
          }
        }else{
          for(let i=0;i<_this.list_info.list.passage.length;i++){
            if(_this.list_info.list.passage[i].passage==_this.list_info.xz_name[0].passage){
              _this.handleEdit(_this.list_info.list.passage[i-1])
              return
            }
          }
        }
      },
      get_list(){
        let _this = this;
          _this.axios
        .get("/v2/user_resource/book_info",
        {params:{book:_this.list_info.num}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.list_info.list=res.data.data
              for(let i=0;i<_this.list_info.list.passage.length;i++){
                if(_this.list_info.list.passage.length-1==i){
                  _this.list_info.len=_this.list_info.list.passage[i]
                }
              }
              _this.$nextTick(() => {
                if(_this.list_info.passage_num!=''){
                  for(let i=0;i<_this.list_info.list.passage.length;i++){
                    if(_this.list_info.passage_num==_this.list_info.list.passage[i].passage){
                      _this.handleEdit(_this.list_info.list.passage[i])
                      if(_this.$route.query.keyword!=''){
                        _this.input=_this.$route.query.keyword
                      }
                      return
                    }
                  }
                }else{
                  _this.handleEdit(_this.list_info.list.passage[0])
                }

              });
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      get_list_info(num){
        let _this = this;
          _this.axios
        .get("/v2/user_resource/book_info",
        {params:{book:_this.list_info.num,passage:num.passage}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.list_info.list=res.data.data
              _this.content=_this.list_info.list.content.content
              if(_this.$route.query.keyword!='null'){
                _this.input=_this.$route.query.keyword
                _this.search()
              }
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      handleEdit(row) {
        this.get_list_info(row)
        this.list_info.xz_name = [row]
         window.scrollTo(0, 0);
         document.getElementById('con').scrollTop = 0;
      },
      isRed({ row }) {
        if(this.list_info.xz_name!=[]){
          const checkIdList = this.list_info.xz_name.map((item) => item.passage);
                if (checkIdList.includes(row.passage)) {
                  return {
                    backgroundColor: " rgba(231, 245, 255,0.8)",
                    color: "#008000",
                  };
                }
        }

      },
    },
  }
</script>

<style scoped>
  /deep/ .el-table tbody tr:hover > td {
    background-color: transparent !important;
    }
  .header_div {
    z-index: 9999;
  }

  .main_sta {
    min-height: calc(100vh - 250px);
    /* width: 70%; */
    padding: 20px;
   /* margin: 0 15%; */
    z-index: 100;
    background-color: white;
  }

  .title {
    padding: 20px;
    overflow: hidden;
  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
 /*设置宽度,轨道颜色*/
 ::-webkit-scrollbar {
 	width: 10px;
 	height: 10px;
 	background:rgb(241, 241, 241) ;   /*可以设置轨道颜色*/
 	padding-right: 2px;
 }

 /*滚动条*/
 ::-webkit-scrollbar-thumb {
 	background: rgb(193, 193, 193);
 	border-radius: 10px;
 }
 p{
   font-size: 0.875rem;
 }


</style>



// WEBPACK FOOTER //
// src/view/visitor/Statute/statute_content.vue